import TagManager from 'react-gtm-module'

import { PaymentMethodEnum, Roles } from 'Constants/enums'
import {
  CampaignStatusEnum,
  Track,
  User,
  FlowType,
  CampaignPlatformTypeEnum,
} from '../Types'

export enum PurchaseTypeEnum {
  FirstPurchase = 'FirstPurchase',
  Purchase = 'purchase',
}

export enum EventTypeEnum {
  Pageview = 'Pageview',
  PaymentDetails = 'payment.details',
  CouponApplied = 'coupon.applied',
  Purchase = 'purchase',
  CRegStart = 'c.reg.start',
  PayoutRequest = 'c.payout.request',
  GenreAdded = 'genre_added',
  GenreRemoved = 'genre_removed',
  LanguagesAdded = 'languages.added',
  LanguageRemoved = 'language_removed',
  LogOut = 'logout',
  NcStart = 'nc.start',
  CreateCampaign = 'CreatedCampaign',
  CampaignSendToReview = 'campaign_send_to_review',
  TrackAdded = 'track.added',
  PhoneAdded = 'phone.number.added',
  RegisterFormFilling = 'filling.form',
  FirstCampaignDetails = 'fc.details',
  CampaignDetails = 'campaign.details',
  ArtistDetails = 'artist.details',
  CreatedFirstCampaign = 'CreatedFirstCampaign',
  CreatedCampaign = 'created_campaign',
  CreateFirstCampaignStart = 'fc.start',
  Login = 'login',
  CampaignBudgetUpdateEvent = 'campaign.budget.update',
  FirstPurchase = 'FirstPurchase',
  StartDateUpdate = 'start.date.update',
  ViewSignUpPopUp = 'view_sign_up_pop-up',
  RegistrationComplete = 'registration_complete',
  CampaignScheduleStart = 'campaign_schedule_start',
  CheckoutView = 'view_checkout_pop_up',
  ReviewRequestSeen = 'review_request_seen',
  ReviewMade = 'review_made',
  TrackAddedToPlaylist = 'track_added_to_playlist',
  ReviewSkipped = 'review_skipped',
  CuratorRegistrationStart = 'curator_registration_start',
  RegistrationCuratorComplete = 'registration_complete',
  PlaylistAdded = 'playlist_added',
  PayoutRequested = 'payout_requested',
  PaymentMethodChanged = 'payment_method_changed',
  CampaignBudgetReceived = 'campaign_budget_received',
  CheckoutConfirmedPayment = 'checkout_confirmed_payment',
  ReviewRequestSeenNotAvailable = 'c_review_request_seen_not_available',
  PaymentCompleted = 'payment_completed',
  MsgLowReachReceived = 'msg_low_reach_received',
  ArtistReviewSent = 'artist_review_sent',
  PaymentCancelled = 'payment_cancelled',
}

export enum EventNameEnum {
  TrackAdded = 'track_added',
  GenreAdded = 'genre_added',
  GenreRemoved = 'genre_removed',
  LanguagesAdded = 'languages.added',
  LanguageRemoved = 'language_removed',
  CampaignSendToReview = 'campaign_send_to_review',
  ViewSignUpPopUp = 'view_sign_up_pop-up',
  RegistrationComplete = 'registration_complete',
  CreatedFirstCampaign = 'CreatedFirstCampaign',
  CreatedCampaign = 'created_campaign',
  CampaignScheduleStart = 'campaign_schedule_start',
  CheckoutView = 'view_checkout_pop_up',
  ReviewRequestSeen = 'review_request_seen',
  ReviewMade = 'review_made',
  TrackAddedToPlaylist = 'track_added_to_playlist',
  ReviewSkipped = 'review_skipped',
  CuratorRegistrationStart = 'curator_registration_start',
  RegistrationCuratorComplete = 'registration_complete',
  PlaylistAdded = 'playlist_added',
  PayoutRequested = 'payout_requested',
  PaymentMethodChanged = 'payment_method_changed',
  CampaignBudgetReceived = 'campaign_budget_received',
  CampaignBudgetUpdateEvent = 'campaign_budget_update',
  CheckoutConfirmedPayment = 'checkout_confirmed_payment',
  ReviewRequestSeenNotAvailable = 'c_review_request_seen_not_available',
  PaymentCompleted = 'payment_completed',
  MsgLowReachReceived = 'msg_low_reach_received',
  ArtistReviewSent = 'artist_review_sent',
  PaymentCancelled = 'payment_cancelled',
}

export const pageInfo = {
  campaignResults: {
    pageTitle: 'Campaign results',
    pagePath: 'https://app.soundcamps.com/campaigns/view',
  },
  scheduleCampaign: {
    pageTitle: 'Schedule campaign',
    pagePath: 'https://app.soundcamps.com/campaigns/schedule',
  },
  balance: {
    pageTitle: 'Balance',
    pagePath: 'https://app.soundcamps.com/balance',
  },
  settings: {
    pageTitle: 'Settings',
    pagePath: 'https://app.soundcamps.com/settings',
  },
  playlists: {
    pageTitle: 'Playlists',
    pagePath: 'https://app.soundcamps.com/playlists',
  },
  reviews: {
    pageTitle: 'Reviews',
    pagePath: 'https://app.soundcamps.com/reviews',
  },
  forgotPassword: {
    pageTitle: 'Forgot password',
    pagePath: 'https://app.soundcamps.com/forgot-password',
  },
  resetPassword: {
    pageTitle: 'Reset password',
    pagePath: 'https://app.soundcamps.com/reset-password',
  },
  rank: {
    pageTitle: 'Rank',
    pagePath: 'https://app.soundcamps.com/rank',
  },
  campaigns: {
    pageTitle: 'Campaigns',
    pagePath: 'https://app.soundcamps.com/campaigns',
  },
  createCampaign: {
    pageTitle: 'Create a new campaign',
    pagePath: 'https://app.soundcamps.com/campaigns/new',
  },
  createCampaignWithoutSignUp: {
    pageTitle: 'Create a new campaign',
    pagePath: 'https://app.soundcamps.com/create',
  },
  createCampaignDetails: {
    pageTitle: 'Create a new campaign',
    pagePath: 'https://app.soundcamps.com/create/details',
  },
  Login: {
    pageTitle: 'Login',
    pagePath: 'https://app.soundcamps.com',
  },
  Checkout: {
    pageTitle: 'Checkout',
    pagePath: 'https://app.soundcamps.com/campaigns/schedule/checkout',
  },
  CheckoutConfirmed: {
    pageTitle: 'Campaign was scheduled',
    pagePath: `https://app.soundcamps.com/campaigns/schedule/checkout/confirmed`,
  },
  CreatedFirstCampaign: {
    pageTitle: 'Created First Campaign',
    pagePath: 'https://app.soundcamps.com/campaigns',
  },
}

export const pageViewEvent = (
  user?: User | null,
  pageInfo?: { pageTitle: string; pagePath: string }
): void => {
  const tagManagerArgs = {
    dataLayer: {
      event: EventTypeEnum.Pageview,
      pageTitle: pageInfo && pageInfo.pageTitle,
      pagePath: pageInfo && pageInfo.pagePath,
      ...(user ? { userID: user?.id || user?.curatorId } : {}),
    },
  }

  TagManager.dataLayer(tagManagerArgs)
}

export const changePaymentMethodEvent = (
  user: User,
  campaignType: CampaignStatusEnum
) => {
  TagManager.dataLayer({
    dataLayer: {
      'campaign-type': campaignType,
      event: EventTypeEnum.PaymentDetails,
      userID: user.id,
    },
  })
}

export const couponAppliedEvent = (
  user: User,
  campaignType: CampaignStatusEnum,
  coupon: { value: string; discount: number },
  discountAmount: string
) => {
  TagManager.dataLayer({
    dataLayer: {
      'campaign-type': campaignType,
      'coupon-name': coupon.value,
      'coupon-value': coupon.discount,
      'discount-value': discountAmount,
      event: 'coupon.applied',
    },
  })
}

export const purchaseEvent = ({
  user,
  campaignId,
  transactionTotal,
  price,
  isFirstCampaign,
}: {
  user: User
  campaignId: string | number
  transactionTotal: number
  price: number
  isFirstCampaign: boolean
}) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.Purchase,
      userID: user.id,
      campaignID: campaignId,
      transactionId: campaignId,
      transactionTotal,
      transactionProducts: [
        {
          sku: isFirstCampaign ? 'S1' : 'S2',
          name: isFirstCampaign
            ? 'Spotify Campaign - First time'
            : 'Spotify Campaign',
          category: 'Spotify',
          price,
          quantity: 1,
        },
      ],
    },
  })
}

export const signUpEvent = (role: string, userId?: number | string): void => {
  const tagManagerLocationArgs = {
    dataLayer: {
      originalLocation: `${document.location.protocol}//${document.location.hostname}${document.location.pathname}${document.location.search}`,
    },
  }

  const tagManagerArgs = {
    dataLayer: {
      event: EventTypeEnum.Pageview,
      pageTitle: 'Sign Up',
      pagePath: `https://app.soundcamps.com/signup-${role}`,
    },
  }

  TagManager.dataLayer(tagManagerLocationArgs)
  TagManager.dataLayer(tagManagerArgs)

  if (role === 'curator') {
    TagManager.dataLayer({
      dataLayer: {
        event: EventTypeEnum.RegistrationComplete,
        event_name: EventNameEnum.RegistrationComplete,
        'account-type': 'curator',
        ...(userId ? { userID: userId } : {}),
      },
    })
  }
}

export const payoutRequestEvent = (user: User, amount: number) => {
  TagManager.dataLayer({
    dataLayer: {
      'user-id': user.curatorId,
      'User-first-name': user.first_name,
      'registration-date': user.createdAt,
      'account-type': 'curator',
      'payout-value': amount,
      event: EventTypeEnum.PayoutRequest,
    },
  })
}

export const genreAddedEventSchedulingCampaign = (
  type: string,
  genreId: string | number,
  genreName: string,
  campaignType?: string,
  userId?: string,
  campaignId?: number,
  campaignNumber?: number
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GenreAdded,
      event_name: EventNameEnum.GenreAdded,
      flow: FlowType.scheduling,
      'campaign-type': type,
      'campaign-platform': campaignType,
      'track-platform': campaignType,
      'campaign-id': campaignId,
      userID: userId,
      'genre-name': genreName,
      'genre-id': genreId,
      'campaign-number': type === 'first' ? 1 : campaignNumber,
    },
  })
}

export const genreRemovedEventSchedulingCampaign = (
  type: string,
  genreId: number,
  genreName: string,
  campaignType?: string,
  userId?: string,
  campaignID?: number
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GenreRemoved,
      event_name: EventNameEnum.GenreRemoved,
      flow: FlowType.scheduling,
      'campaign-type': type,
      'campaign-platform': campaignType,
      'track-platform': campaignType,
      'campaign-id': campaignID,
      userID: userId,
      'genre-name': genreName,
      'genre-id': genreId,
    },
  })
}

export const languageAddedEventSchedulingCampaign = (
  type: string,
  languageId: string | number,
  languageName: string,
  campaignType?: string,
  userId?: string,
  campaignId?: number,
  campaignNumber?: number
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.LanguagesAdded,
      event_name: EventNameEnum.LanguagesAdded,
      flow: FlowType.scheduling,
      'campaign-type': type,
      'campaign-platform': campaignType,
      'track-platform': campaignType,
      'campaign-id': campaignId,
      userID: userId,
      'language-name': languageName,
      'language-id': languageId,
      'campaign-number': type === 'first' ? 1 : campaignNumber,
    },
  })
}

export const locationEvent = () => {
  const tagManagerLocationArgs = {
    dataLayer: {
      originalLocation: `${document.location.protocol}//${document.location.hostname}${document.location.pathname}${document.location.search}`,
    },
  }
  TagManager.dataLayer(tagManagerLocationArgs)
}

export const logOutEvent = (user: User) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.LogOut,
      userID: user.id,
      'User-first-name': user.first_name,
      'registration-date': user.createdAt,
      'account-type': user.role,
      'user-role': user.role,
    },
  })
}

export const createCampaignStartEvent = (
  user: User,
  campaignNumber: number
) => {
  TagManager.dataLayer({
    dataLayer: {
      'campaign-type': user.is_first_campaign ? 'first' : 'basic',
      'campaign-platform': CampaignPlatformTypeEnum.SPOTIFY,
      'campaign-number': campaignNumber || 1,
      userID: user.id,
      'User-first-name': user.first_name,
      'registration-date': user.createdAt,
      'account-type': 'musician',
      'user-role': user.role,
      event: EventTypeEnum.NcStart,
    },
  })
}

export const campaignSentToReviewEvent = (
  isFirstCampaign: boolean,
  campaignType: string,
  campaignNumber?: number | string,
  userId?: string
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.CampaignSendToReview,
      event_name: EventNameEnum.CampaignSendToReview,
      'campaign-type':
        (isFirstCampaign && campaignNumber === 1) || !userId ? 'first' : 'new',
      'campaign-platform': campaignType,
      'campaign-number': campaignNumber,
      ...(userId ? { userID: userId } : {}),
    },
  })
}

export const createFirstCampaignStartEvent = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.CreateFirstCampaignStart,
    },
  })
}

export const createCampaignEvent = (user: User, campaignId: string) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.CreateCampaign,
      userID: user.id,
      campaignID: campaignId,
      pageTitle: 'Created Campaign',
      pagePath: 'https://app.soundcamps.com/campaigns',
    },
  })
}
export const trackAddedEvent = (
  track: Track,
  isFirstCampaign: boolean,
  campaignType: string,
  campaignNumber?: number,
  userId?: string
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.TrackAdded,
      event_name: EventNameEnum.TrackAdded,
      'campaign-type':
        (isFirstCampaign && campaignNumber === 1) || !userId ? 'first' : 'new',
      'campaign-platform': campaignType,
      'track-platform': campaignType,
      'campaign-number': campaignNumber || 1,
      ...(userId ? { userID: userId } : {}),
      'track-name': track.name,
      ...(track.duration_m ? { 'track-length': track.duration_m } : {}),
      'track-id': track.id,
      'track-artist-name': track.artists[0].name,
    },
  })
}

export const phoneNumberAddedEvent = () => {
  TagManager.dataLayer({
    dataLayer: {
      'campaign-type': 'first',
      event: EventTypeEnum.PhoneAdded,
    },
  })
}

export const fillingRegisterFormEvent = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.RegisterFormFilling,
    },
  })
}

export const firstCampaignDetailsEvent = (track: Track) => {
  TagManager.dataLayer({
    dataLayer: {
      'campaign-type': 'first',
      'campaign-platform': CampaignPlatformTypeEnum.SPOTIFY,
      'campaign-number': '1',
      'track-name': track.name,
      'track-length': track.duration_ms,
      'track-id': track.id,
      'track-artist-name': track.artists[0].name,
      event: EventTypeEnum.FirstCampaignDetails,
    },
  })
}

export const campaignDetailsEvent = (
  campaignType: string,
  campaignNumber: number
) => {
  TagManager.dataLayer({
    dataLayer: {
      'campaign-type': 'new',
      'campaign-platform': campaignType,
      'campaign-number': campaignNumber,
      event: EventTypeEnum.CampaignDetails,
    },
  })
}

export const fistCampaignArtistDetailsEvent = () => {
  TagManager.dataLayer({
    dataLayer: {
      'campaign-type': 'first',
      event: EventTypeEnum.ArtistDetails,
    },
  })
}

export const createdFirstCampaignEvent = (
  campaignType: string,
  campaignInfo: {
    user: {
      id: string
      role: string
    }
    spotify_campaign: {
      id: string
    }
  }
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.CreatedFirstCampaign,
      event_name: EventNameEnum.CreatedFirstCampaign,
      'campaign-type': 'first',
      'campaign-platform': campaignType,
      'campaign-number': '1',
      'campaign-id': campaignInfo.spotify_campaign.id,
      userID: campaignInfo.user.id,
      pageTitle: pageInfo.CreatedFirstCampaign.pageTitle,
      pagePath: pageInfo.CreatedFirstCampaign.pagePath,
    },
  })
}

export const createdCampaignEvent = (
  isFirstCampaign: boolean,
  campaignType: string,
  campaignId: number | string,
  userId: number | string,
  campaignNumber?: number,
  is_feed?: boolean
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.CreatedCampaign,
      event_name: EventNameEnum.CreatedCampaign,
      'campaign-type':
        (isFirstCampaign && campaignNumber === 1) || !userId ? 'first' : 'new',
      'campaign-platform': campaignType,
      'campaign-number': campaignNumber,
      'campaign-id': campaignId,
      userID: userId,
      is_feed,
    },
  })
}

export const loginEvent = (user: User) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.Login,
      userID: user.id,
      'User-first-name': user.first_name,
      'registration-date': user.createdAt,
      'account-type': user.role,
      'user-role': user.role,
    },
  })
}

export const campaignBudgetUpdateEvent = (
  type: string,
  campaignType: string,
  campaignNumber: number,
  campaignId: number,
  userId: number | string,
  price: number,
  genreList: string,
  languageList: string,
  is_feed?: boolean
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.CampaignBudgetUpdateEvent,
      event_name: EventNameEnum.CampaignBudgetUpdateEvent,
      flow: 'scheduling_campaign',
      'campaign-type': type,
      'campaign-platform': campaignType,
      'campaign-number': type === 'first' ? 1 : campaignNumber,
      'campaign-id': campaignId,
      ...(userId ? { userID: userId } : {}),
      'result-price': price,
      'genre-list': genreList,
      language_list: languageList,
      is_feed,
    },
  })
}

export const firstPurchaseEvent = () => {
  const tagManagerArgsIfFirstCampaign = {
    dataLayer: {
      event: EventTypeEnum.FirstPurchase,
      pageTitle: 'First Campaign Paid',
      pagePath: `https://app.soundcamps.com/campaigns/schedule/checkout/confirmed`,
    },
  }

  TagManager.dataLayer(tagManagerArgsIfFirstCampaign)
}

export const changeStartDateEvent = (campaignType: string) => {
  TagManager.dataLayer({
    dataLayer: {
      'campaign-type': campaignType,
      event: EventTypeEnum.StartDateUpdate,
    },
  })
}

export const viewSignUpPopUpEvent = (campaignType: string) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.ViewSignUpPopUp,
      event_name: EventNameEnum.ViewSignUpPopUp,
      'campaign-type': 'first',
      'campaign-platform': campaignType,
      'campaign-number': '1',
    },
  })
}

export const registrationCompleteEvent = (
  campaignType: string,
  campaignInfo: {
    user: {
      id: string
      role: string
    }
    spotify_campaign: {
      id: string
      is_feed?: boolean
    }
  }
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.RegistrationComplete,
      event_name: EventNameEnum.RegistrationComplete,
      'campaign-type': 'first',
      'campaign-platform': campaignType,
      'campaign-number': '1',
      'campaign-id': campaignInfo.spotify_campaign.id,
      userID: campaignInfo.user.id,
      'account-type': campaignInfo.user.role,
      'user-role': campaignInfo.user.role,
      is_feed: campaignInfo.spotify_campaign.is_feed || false,
    },
  })
}

export const campaignScheduleStartEvent = (
  type: string | undefined,
  genreList: string,
  languageList: string,
  campaignID: number | string,
  campaignType?: string,
  userId?: number | string,
  campaignNumber?: number,
  is_feed?: boolean
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.CampaignScheduleStart,
      event_name: EventNameEnum.CampaignScheduleStart,
      'campaign-type': type,
      'campaign-platform': campaignType,
      'campaign-number': type === 'first' ? 1 : campaignNumber,
      'campaign-id': campaignID,
      userID: userId,
      ...(genreList ? { 'genre-list': genreList } : {}),
      ...(languageList ? { language_list: languageList } : {}),
      is_feed,
    },
  })
}

export const checkoutViewEvent = ({
  campaignType,
  genreList,
  languageList,
  campaignID,
  price,
  campaignPlatform,
  userId,
  campaignNumber,
  paymentMethod,
  is_feed,
}: {
  campaignType: string
  genreList: string
  languageList: string
  campaignID: number | string
  price: number
  userId?: number | string
  campaignNumber?: number
  campaignPlatform: CampaignPlatformTypeEnum
  paymentMethod: PaymentMethodEnum
  is_feed?: boolean
}) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.CheckoutView,
      event_name: EventNameEnum.CheckoutView,
      'campaign-type': campaignType,
      'campaign-platform': campaignPlatform,
      'campaign-number': campaignType === 'first' ? 1 : campaignNumber,
      'campaign-id': campaignID,
      ...(userId ? { userID: userId } : {}),
      'genre-list': genreList,
      language_list: languageList,
      'result-price': price,
      payment_method: paymentMethod,
      is_feed,
    },
  })
}

export const reviewRequestSeenEvent = (
  requestId: number | string,
  campaignID: number | string,
  campaignType: string,
  userId?: number | string,
  is_feed?: boolean | string
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.ReviewRequestSeen,
      event_name: EventNameEnum.ReviewRequestSeen,
      'account-type': 'curator',
      ...(userId ? { userID: userId } : {}),
      'request-id': requestId,
      'campaign-platform': campaignType,
      'campaign-id': campaignID,
      is_feed,
    },
  })
}

export const reviewMadeEvent = (
  campaignID: number | string,
  campaignType: string,
  isTrackAdded: boolean,
  userId: number | string,
  reviewtId?: number | string,
  amount?: number,
  rejectionReasonId?: number | string,
  rejectionReason?: string,
  is_feed?: boolean
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.ReviewMade,
      event_name: EventNameEnum.ReviewMade,
      'account-type': 'curator',
      ...(userId ? { userID: userId } : {}),
      ...(reviewtId ? { 'review-id': reviewtId } : {}),
      'campaign-platform': campaignType,
      'campaign-id': campaignID,
      ...(amount ? { amount_paid: amount } : {}),
      ...(isTrackAdded ? { is_track_added: isTrackAdded } : {}),
      ...(rejectionReason ? { rejection_reason: rejectionReason } : {}),
      ...(rejectionReasonId ? { rejection_reason_id: rejectionReasonId } : {}),
      is_feed,
    },
  })
}

export const trackAddedToPlaylistEvent = (
  campaignID: number | string,
  campaignType: string,
  userId: number | string,
  reviewtId?: number,
  amount?: number,
  trackId?: number,
  is_feed?: boolean
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.TrackAddedToPlaylist,
      event_name: EventNameEnum.TrackAddedToPlaylist,
      'account-type': 'curator',
      ...(userId ? { userID: userId } : {}),
      ...(reviewtId ? { 'review-id': reviewtId } : {}),
      'campaign-platform': campaignType,
      'campaign-id': campaignID,
      amount_paid: amount,
      'track-id': trackId,
      is_feed,
    },
  })
}

export const reviewSkippedEvent = (
  campaignID: number | string,
  reviewtId: number | string,
  campaignType: string,
  amount: string | number,
  userId: number | string,
  is_feed?: boolean
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.ReviewSkipped,
      event_name: EventNameEnum.ReviewSkipped,
      'account-type': 'curator',
      ...(userId ? { userID: userId } : {}),
      ...(reviewtId ? { 'review-id': reviewtId } : {}),
      'campaign-platform': campaignType,
      'campaign-id': campaignID,
      amount_paid: amount,
      is_feed,
    },
  })
}

export const curatorRegistrationStartEvent = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.CuratorRegistrationStart,
      event_name: EventNameEnum.CuratorRegistrationStart,
      'account-type': 'curator',
    },
  })

  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.CRegStart,
    },
  })
}

export const playlistAddedEvent = (
  isValid: boolean,
  campaignType: string,
  playlistId?: string | number,
  userId?: number | string
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.PlaylistAdded,
      event_name: EventNameEnum.PlaylistAdded,
      'account-type': 'curator',
      ...(userId ? { userID: userId } : {}),
      is_valid: isValid,
      playlist_id: playlistId,
      'track-platform': campaignType,
    },
  })
}

export const payoutRequestedEvent = (
  payoutAmount: number,
  payoutRequestId?: number,
  userId?: string
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.PayoutRequested,
      event_name: EventNameEnum.PayoutRequested,
      'account-type': 'curator',
      ...(userId ? { userID: userId } : {}),
      payout_amount: payoutAmount,
      ...(payoutRequestId ? { payout_request_id: payoutRequestId } : {}),
    },
  })
}

export const paymentMethodChanged = ({
  campaignType,
  campaignPlatform,
  campaignNumber,
  campaignId,
  userId,
  resultPrice,
  genreList,
  languageList,
  paymentMethod,
  prevPaymentMethod,
  is_feed,
}: {
  campaignType: string
  campaignPlatform: CampaignPlatformTypeEnum
  campaignNumber: number
  campaignId: number
  userId: number | string
  resultPrice: number
  genreList: string
  languageList: string
  paymentMethod: PaymentMethodEnum
  prevPaymentMethod: PaymentMethodEnum
  is_feed?: boolean
}) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.PaymentMethodChanged,
      event_name: EventNameEnum.PaymentMethodChanged,
      flow: 'checkout',
      'campaign-type': campaignType,
      'campaign-platform': campaignPlatform,
      'campaign-number': campaignType === 'first' ? 1 : campaignNumber,
      'campaign-id': campaignId,
      ...(userId ? { userID: userId } : {}),
      'result-price': resultPrice,
      'genre-list': genreList,
      language_list: languageList,
      payment_method: paymentMethod,
      prev_payment_method: prevPaymentMethod,
      is_feed,
    },
  })
}

export const campaignBudgetReceived = (
  type: string,
  campaignType: string,
  campaignNumber: number,
  campaignId: number,
  userId: number | string,
  resultPrice: number,
  genreList: string,
  languageList: string,
  is_feed?: boolean
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.CampaignBudgetReceived,
      event_name: EventNameEnum.CampaignBudgetReceived,
      flow: 'scheduling_campaign',
      'campaign-type': type,
      'campaign-platform': campaignType,
      'campaign-number': type === 'first' ? 1 : campaignNumber,
      'campaign-id': campaignId,
      ...(userId ? { userID: userId } : {}),
      'result-price': resultPrice,
      'genre-list': genreList,
      language_list: languageList,
      is_feed,
    },
  })
}

export const checkoutConfirmedPayment = ({
  campaignPlatform,
  campaignType,
  campaignNumber,
  campaignId,
  userId,
  resultPrice,
  genreList,
  languageList,
  paymentMethod,
  is_feed,
}: {
  campaignPlatform: CampaignPlatformTypeEnum
  campaignType: string
  campaignNumber: number
  campaignId: number
  userId: number | string
  resultPrice: number
  genreList?: string
  languageList?: string
  paymentMethod: PaymentMethodEnum
  is_feed?: boolean
}) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.CheckoutConfirmedPayment,
      event_name: EventNameEnum.CheckoutConfirmedPayment,
      flow: 'checkout',
      'campaign-type': campaignType,
      'campaign-platform': campaignPlatform,
      'campaign-number': campaignType === 'first' ? 1 : campaignNumber,
      'campaign-id': campaignId,
      ...(userId ? { userID: userId } : {}),
      ...(resultPrice ? { 'result-price': resultPrice } : {}),
      'genre-list': genreList,
      language_list: languageList,
      payment_method: paymentMethod,
      is_feed,
    },
  })
}

export const paymentCompletedEvent = ({
  campaignType,
  campaignPlatformType,
  campaignNumber,
  campaignId,
  userId,
  userRole,
  campaignValue,
  genresList,
  languagesList,
  isDanceRequired = false,
  paymentAmount,
  transactionId,
  purchaseType,
  paymentMethod,
  is_feed,
}: {
  campaignType: string
  campaignPlatformType: CampaignPlatformTypeEnum
  campaignNumber: number
  campaignId: number | string
  userId: number | string
  userRole: Roles
  campaignValue: number
  genresList: string
  languagesList: string
  isDanceRequired?: boolean
  paymentAmount: number
  transactionId: string
  purchaseType: PurchaseTypeEnum
  paymentMethod: PaymentMethodEnum
  is_feed?: boolean
}) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.PaymentCompleted,
      event_name: EventNameEnum.PaymentCompleted,
      flow: 'checkout',
      'campaign-type': campaignType,
      'campaign-platform': campaignPlatformType,
      'campaign-number': campaignNumber,
      'campaign-id': campaignId,
      userID: userId,
      'account-type': userRole,
      'result-price': campaignValue,
      'genre-list': genresList,
      language_list: languagesList,
      dance_required: isDanceRequired,
      affiliation: 'web,',
      value: paymentAmount,
      currency: 'USD',
      transaction_id: transactionId,
      purchase_type: purchaseType,
      payment_method: paymentMethod,
      is_feed,
    },
  })
}

export const artistReviewSentEvent = (
  type: string,
  campaignType: string,
  campaignNumber: number,
  campaignId: number,
  userId: number | string,
  rateStars: number,
  responseText: string,
  reviewId: string | number,
  is_feed?: boolean,
  responseId?: number,
  isDanceRequired?: boolean
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.ArtistReviewSent,
      event_name: EventNameEnum.ArtistReviewSent,
      flow: 'artist_review_section',
      'campaign-type': type,
      'campaign-platform': campaignType,
      'campaign-number': type === 'first' ? 1 : campaignNumber,
      'campaign-id': campaignId,
      ...(userId ? { userID: userId } : {}),
      rate_stars: rateStars,
      response_text: responseText,
      ...(responseId ? { response_id: responseId } : {}),
      review_id: reviewId,
      is_feed,
      ...(isDanceRequired ? { dance_required: isDanceRequired } : {}),
    },
  })
}

// Check for avoid duplicated GTM requests
export const checkIsGTMPaymentEventNeeded = (
  campaignId: number | string,
  paymentResult: 'success' | 'failure'
): boolean => {
  const stringCampaignId = String(campaignId)
  const storageKey =
    paymentResult === 'success' ? 'stripeGtmSuccess' : 'stripeGtmFailure'

  const successSentCampaigns = localStorage.getItem(storageKey)

  if (successSentCampaigns) {
    const successSentGTMCampaigns = successSentCampaigns.split(',')

    if (!successSentGTMCampaigns.includes(stringCampaignId)) {
      successSentGTMCampaigns.push(stringCampaignId)
      const newSuccessGTMCampaigns = successSentGTMCampaigns.join(',')
      localStorage.setItem(storageKey, newSuccessGTMCampaigns)
      return true
    }

    return false
  }
  localStorage.setItem(storageKey, stringCampaignId)
  return true
}

export const msgLowReachReceived = (
  type: string,
  campaignType: string,
  campaignNumber: number,
  campaignId: string,
  userId: number | string,
  genreList?: string,
  languageList?: string,
  is_feed?: boolean,
  danceRequired?: boolean
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.MsgLowReachReceived,
      event_name: EventNameEnum.MsgLowReachReceived,
      flow: 'scheduling_campaign',
      'campaign-type': type,
      'campaign-platform': campaignType,
      'campaign-number': type === 'first' ? 1 : campaignNumber,
      'campaign-id': campaignId,
      ...(userId ? { userID: userId } : {}),
      'result-price': 0,
      'genre-list': genreList,
      language_list: languageList,
      is_feed,
      ...(danceRequired ? { dance_required: danceRequired } : {}),
    },
  })
}

export const reviewRequestSeenNotAvailableEvent = (
  campaignType: string,
  campaignId: number,
  userId: string,
  requestId: number | string,
  is_feed?: boolean
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.ReviewRequestSeenNotAvailable,
      event_name: EventNameEnum.ReviewRequestSeenNotAvailable,
      'account-type': 'curator',
      ...(userId ? { userID: userId } : {}),
      'request-id': requestId,
      'campaign-platform': campaignType,
      'campaign-id': campaignId,
      is_available: 'false',
      is_feed,
    },
  })
}
export const paymentCancelledEvent = ({
  campaignType,
  campaignPlatformType,
  campaignNumber,
  campaignId,
  userId,
  userRole,
  campaignValue,
  genresList,
  languagesList,
  isFeedCampaign = false,
  isDanceRequired = false,
  paymentAmount,
  purchaseType,
  paymentMethod,
}: {
  campaignType: string
  campaignPlatformType: CampaignPlatformTypeEnum
  campaignNumber: number
  campaignId: number | string
  userId: number | string
  userRole: string
  campaignValue: number
  genresList: string
  languagesList: string
  isFeedCampaign?: boolean
  isDanceRequired?: boolean
  paymentAmount: number | string | null
  purchaseType: PurchaseTypeEnum
  paymentMethod: PaymentMethodEnum
}) => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.PaymentCancelled,
      event_name: EventNameEnum.PaymentCancelled,
      flow: 'checkout',
      'campaign-type': campaignType,
      'campaign-platform': campaignPlatformType,
      'campaign-number': campaignNumber,
      'campaign-id': campaignId,
      userID: userId,
      'account-type': userRole,
      'result-price': campaignValue,
      'genre-list': genresList,
      language_list: languagesList,
      is_feed: isFeedCampaign,
      dance_required: isDanceRequired,
      affiliation: 'web,',
      value: paymentAmount,
      currency: 'USD',
      purchase_type: purchaseType,
      payment_method: paymentMethod,
    },
  })
}
